<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->

    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row>
        <v-col cols="12" sm="9">
          <h2>{{ mission.questionName || "• • •" }}</h2>
        </v-col>
        <v-col cols="12" sm="3" class="d-flex justify-end">
          <v-btn
            rounded
            color="error"
            :to="{
              name: 'PageEducatorInstitutionClassroomStudentMissionRemove',
              params: {
                id: $route.params.id,
                parentId: $route.params.parentId,
                grandparentId: $route.params.grandparentId,
                supergrandparentId: $route.params.supergrandparentId,
              },
            }"
          >
            Remove
          </v-btn>
        </v-col>
      </v-row>

      <v-card-title></v-card-title>

      <ALoader :isLoading="api.isLoading || studentApi.isLoading" />

      <Read
        v-if="!api.isLoading && !studentApi.isLoading"
        :headers="missionHeaders"
        :data="mission"
      />
    </v-card>
  </v-container>
</template>

<script>
import Read from "../../components/Bread/Mission/Read.vue";

export default {
  components: {
    Read,
  },
  data: () => ({
    // BOC:[breadcrumbs]
    breadcrumbs: [],
    // EOC
    mission: {},
    questionName: "",
    mochiId: null,
    // APIs
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
      method: "GET",
    },
    questionApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
      params: {},
      method: "post",
    },
    studentApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
      method: "GET",
    },
    missionHeaders: [
      { text: "Name", value: "questionName" },
      { text: "Status", value: "status" },
      { text: "Grade", value: "grade" },
      { text: "Stars", value: "stars" },
      { text: "Assigned At", value: "timestampCreated" },
      { text: "Last Played", value: "timestampUpdated" },
    ],
  }),
  created() {
    // setup API callbacks
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.mission = resp || {};
      if (resp && resp.questionKey) {
        this.fetchQuestionName(resp.questionKey);
      }
    };

    this.loadStudent(); // fetch student for breadcrumbs + mochiId, then fetch mission
  },
  methods: {
    loadStudent() {
      this.studentApi.url =
        this.$api.servers.sso +
        "/api/v1/" +
        this.$_getLocale() +
        "/educator/classroom/" +
        this.$route.params.grandparentId +
        "/student/" +
        this.$route.params.parentId;

      this.studentApi.callbackReset = () => {
        this.studentApi.isLoading = true;
        this.studentApi.isError = false;
      };
      this.studentApi.callbackError = (e) => {
        this.studentApi.isLoading = false;
        this.studentApi.isError = true;
        this.studentApi.error = e;
        this.updateBreadcrumb({});
      };
      this.studentApi.callbackSuccess = (resp) => {
        this.studentApi.isLoading = false;
        this.updateBreadcrumb(resp || {});
        this.mochiId = resp && resp.mochiId ? resp.mochiId : null;

        if (this.mochiId) {
          this.api.url =
            this.$api.servers.game +
            "/api/v1/" +
            this.$_getLocale() +
            "/backend/player/" +
            this.mochiId +
            "/mission/" +
            this.$route.params.id;
          this.$api.fetch(this.api);
        }
      };

      this.$api.fetch(this.studentApi);
    },

    updateBreadcrumb(resp) {
      this.breadcrumbs = [
        {
          text: "Dashboard",
          to: { name: "PageEducatorDashboard" },
          exact: true,
        },
      ];

      this.breadcrumbs.push({
        text: "My Institution",
        to: {
          name: "PageEducatorInstitutionDashboard",
          params: { id: this.$route.params.supergrandparentId },
        },
        exact: true,
      });

      this.breadcrumbs.push({
        text: "Classrooms",
        to: {
          name: "PageEducatorInstitutionClassroom",
          params: { id: this.$route.params.supergrandparentId },
        },
        exact: true,
      });

      if (resp && resp.Classroom && resp.Classroom.name) {
        this.breadcrumbs.push({
          text: resp.Classroom.name,
          to: {
            name: "PageEducatorInstitutionClassroomDashboard",
            params: {
              id: this.$route.params.grandparentId,
              parentId: this.$route.params.supergrandparentId,
            },
          },
          exact: true,
        });
      }

      this.breadcrumbs.push({
        text: "Students",
        to: {
          name: "PageEducatorInstitutionClassroomStudent",
          params: {
            id: this.$route.params.grandparentId,
            parentId: this.$route.params.supergrandparentId,
          },
        },
        exact: true,
      });

      if (resp && resp.name) {
        this.breadcrumbs.push({
          text: resp.name,
          to: {
            name: "PageEducatorInstitutionClassroomStudentRead",
            params: {
              id: this.$route.params.parentId,
              parentId: this.$route.params.grandparentId,
              grandparentId: this.$route.params.supergrandparentId,
            },
          },
          exact: true,
        });
      }

      this.breadcrumbs.push({
        text: "Mission",
        to: {
          name: "PageEducatorInstitutionClassroomStudentMissionRead",
          params: {
            id: this.$route.params.id,
            parentId: this.$route.params.parentId,
            grandparentId: this.$route.params.grandparentId,
            supergrandparentId: this.$route.params.supergrandparentId,
          },
        },
        exact: false,
      });
    },

    fetchQuestionName(questionKey) {
      if (!questionKey) return;

      this.questionApi.url = `${process.env.VUE_APP_URL_API_QUESTION}/v2/questions`;

      this.questionApi.callbackReset = () => {
        this.questionApi.isLoading = true;
        this.questionApi.isError = false;
      };
      this.questionApi.callbackError = (e) => {
        this.questionApi.isLoading = false;
        this.questionApi.isError = true;
        this.questionApi.error = e;
      };
      this.questionApi.callbackSuccess = (resp) => {
        this.questionApi.isLoading = false;
        if (resp && resp.length) {
          const q = resp[0];
          this.questionName = q.name || q.questionName || questionKey;
          this.$set(this.mission, "questionName", this.questionName);
        }
      };

      this.questionApi.params = {
        key: questionKey,
        lang: this.$_getLocale(),
        count: 1,
        showOption: false,
      };

      this.$api.fetch(this.questionApi);
    },
  },
};
</script>

<style scoped>
.form-content {
  width: 600px !important;
}
</style>